module.exports = __webpack_public_path__ + "img/bottom_logo.dc0d8e61.png";